import React from 'react';
import { NewsBlock } from '@components/news/NewsBlock';
import { NewsAndStoriesItem } from '@pages/NewsAndStories/NewsAndStories.types';
import { Topics } from '@components/news/Topics';
import './NewsAndStoriesList.scss';

interface NewsAndStoriesListProps {
  topics: {
    position: number;
    title: string;
    items: Array<{ Name: string; Url: string }>;
  };
  items: Array<NewsAndStoriesItem>;
}

export const NewsAndStoriesList = ({ items, topics }: NewsAndStoriesListProps) => {
  const moreItemsThanTopicPosition = topics.position < items.length;
  return (
    <div className='news-and-stories-list'>
      {items.map((item, index) => {
        return (
          <>
            {moreItemsThanTopicPosition && index === topics.position && (
              <Topics
                key={topics.title}
                title={topics.title}
                data={topics.items || []}
                noBackground
              />
            )}
            <NewsBlock
              key={item.ContentLink}
              Title={item.Title}
              Topic={item.TopicName}
              TopicUrl={item.TopicUrl}
              PublishDate={item.Date}
              Description={item.Introduction}
              Image={item.Image}
              ImageUrl={item.ContentLink}
              imagePosition='top'
            />
          </>
        );
      })}
      {!moreItemsThanTopicPosition && (
        <Topics key={topics.title} title={topics.title} data={topics.items || []} noBackground />
      )}
    </div>
  );
};
